import styled, { css } from 'styled-components';

const SCErrorBox = styled.div`
    background-color: white;
    border: 2px solid ${p => p.theme.color.red};
    border-radius: 3px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    min-height: 150px;
    width: 90%;
    max-width: 500px;
    position: absolute;
    left: 5%;
    top: 10%;
    padding: 10px;
    text-align: center;
    z-index: 1002;
    transition: all .2s ease-in-out;
    transform: translateY(-200%);

    ${p =>
      p.errorMsg !== '' &&
      css`
        transform: translateY(0);
      `}

    @media(${p => p.theme.mq.desktop}) {
        left: calc(50% - 500px/2);
    }
`;

export default SCErrorBox;



// WEBPACK FOOTER //
// ./src/components/ErrorPopup/styles.js